import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import { Content } from './components';
import { constBreadCrumbsTitle, getDynamicReportPages } from 'utility';
import { Content as ContentOld } from '../InvoiceDebtor/components';
import { useCurrencyUnit } from 'hooks';

const InvoiceList = () => {
  const reportElement = getDynamicReportPages(['menuInvoice'])
  const currencyText = useCurrencyUnit(false);
  
  const hint =
    'در این صفحه فاکتورهایی که توسط کسب‌وکار شما صادر شده و یا کسب‌وکار شما سهمی از آن می‌برد، را مشاهده می‌نمایید. قابلیت فیلتر کردن روی فیلدهای مختلف و دریافت فایل خروجی نیز وجود دارد.';

  return (
    <PageContainer
      title=" فاکتورهای فروش"
      description={hint}
      pageKey="invoiceDebtor"
      breadcrumbs={constBreadCrumbsTitle.INVOICE_LIST}
    >
      <CommonProvider>
        {
          reportElement['menuInvoice'] ? (<Content currencyText={currencyText}/>) : (<ContentOld currencyText={currencyText} />)
        }
        
      </CommonProvider>
    </PageContainer>
  );
};

export default InvoiceList;
